import React, { useEffect, useState } from "react";

import { Box, Typography, keyframes } from "@mui/material";

import { isDarkMode } from "@/src/theme/helpers";
import { schemeSx } from "@/src/theme/schemeStyles";
import { theme } from "@/src/theme/theme";

import { HOMEPAGE_FRONT_PAGE_CONTAINER_STYLES } from "@/src/pages/consumer/HomePage/homePage.constants";

import { Testimonial, getTestimonialList } from "@/src/utils/testimonialsUtils";

const fadeAnimation = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const Testimonials = () => {
  const [, setCurrentTestimonialIndex] = useState(0);
  const [isFading, setIsFading] = useState(false);
  const [testimonialList, setTestimonialList] = useState<Testimonial[]>([]);
  const [currentTestimonial, setCurrentTestimonial] = useState<Testimonial>();

  useEffect(() => {
    const getInitialTestimonialList = async () => {
      const testimonialList = await getTestimonialList();
      setTestimonialList(testimonialList);
      setCurrentTestimonial(testimonialList[0]);
    };

    getInitialTestimonialList();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonialIndex((prevIndex) => {
        const newIndex = (prevIndex + 1) % testimonialList.length;
        setCurrentTestimonial(testimonialList[newIndex]);
        setIsFading(true);

        setTimeout(() => {
          setIsFading(false);
        }, 3000);

        return newIndex;
      });
    }, 8000);

    return () => {
      clearInterval(interval);
    };
  }, [testimonialList]);

  return (
    <Box
      sx={{
        ...HOMEPAGE_FRONT_PAGE_CONTAINER_STYLES,
        textAlign: "center",
        animation: isFading ? `${fadeAnimation} 3s linear` : "none",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        // Reserve room so the page doesn't jump between quotes; minHeight
        // instead of height so a long quote on a narrow phone isn't clipped.
        // Includes the container's top and bottom padding (border-box).
        minHeight: [284, 244]
      }}
    >
      <Typography
        variant="h2"
        sx={schemeSx((muiTheme) => ({
          maxWidth: 700,
          fontWeight: theme.typography.fontWeightRegular,
          color: isDarkMode(muiTheme)
            ? muiTheme.palette.text.primary
            : theme.palette.semantic.primary.main,
          padding: 0,
          margin: 0,
          fontStyle: "italic"
        }))}
      >
        {currentTestimonial ? <q>{currentTestimonial?.text}</q> : ""}
      </Typography>
    </Box>
  );
};

export default Testimonials;
